//API serivice FUNCTIONS
import { setPageLoader } from "../../Redux/features/utils.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import moment from "moment";
import { setDynamicAdjustments } from "../../Redux/features/dynamicAdjustments.slice";

const { dynamicAdjustments } = apiRoutes;

const getDynamicAdjustmentList = async (dispatch, selector) => {

    dispatch(setPageLoader({ page: 'dynamicAdjustments', flag: true }))

    let { plant = null, machine = null, line = null, shift = null } = selector
    let start = `${moment(Date.now()).utc().format(`YYYY-MM-DDT${shift?.from}:00.000`)}Z`;
    let end = `${moment(Date.now()).utc().format(`YYYY-MM-DDT${shift?.to}:00.000`)}Z`;
    let response = await postRequest({
        endPoint: dynamicAdjustments.list,
        body: { "conditions": {"createdAt": {"$gte": start, "$lt": end}, "plantId": plant?._id, "lineId": line?.id, "machine": machine?.machineName, "attributes": undefined}}
            // `{%22createdAt%22:{%22$gte%22:%22${start}%22,%22$lt%22:%22${end}%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:%22${machine?.machineName}%22}&attributes=undefined`
    })
    console.log(response, 'responseeee')
    if (response.success === true) {
        dispatch(setDynamicAdjustments({ list: response?.response }))
    }
    dispatch(setPageLoader({ page: 'dynamicAdjustments', flag: false }))
}



export {
    getDynamicAdjustmentList
}